import { getErrorMessage } from '../../../constants/utils';
import { GamesApi } from '../../../services/games-service';
import { error } from '../notifications';

export const GET_GAME_HIGHLIGHT_LIST = 'GET_GAME_HIGHLIGHT_LIST';
export const GAME_HIGHLIGHT_COLOURS = 'GAME_HIGHLIGHT_COLOURS';
export const INIT_GAME_HIGHLIGHT_LIST = 'INIT_GAME_HIGHLIGHT_LIST';
export const CURRENT_GAME_HIGHLIGHT = 'CURRENT_GAME_HIGHLIGHT';
export const UPDATE_NEW_GAME_CHECKED = 'UPDATE_NEW_GAME_CHECKED';
export const INIT_CURRENT_GAME = 'INIT_CURRENT_GAME';
export const GAME_LIST = 'GAME_LIST';
export const SET_ACTION = 'SET_ACTION';
export const SET_LOADING = 'SET_LOADING';
const GAME_HIGHLIGHT_LIST_PAGE_TARGET = 'GameHighlightsPage';
const GAME_HIGHLIGHT_CREATE_PAGE_TARGET = 'CreateGameHighlights';
export const GAME_STOCK = 'GAME_STOCK';

const gamesApi = new GamesApi();

export const GameHighlightsError = (errors, target) => {
    return (dispatch) => {
        dispatch(
            error({
                msg: getErrorMessage(errors),
                target: target,
            }),
        );
    };
};

export const getGameList = () => {
    return async (dispatch) => {
        try {
            const gameList = await gamesApi.findAllGames();
            dispatch({
                type: GAME_LIST,
                payload: gameList,
            });
        } catch (err) {
            console.error(err);
            dispatch(GameHighlightsError(err, GAME_HIGHLIGHT_LIST_PAGE_TARGET));
        } finally {
            dispatch(setLoading(false));
        }
    };
};

export const getGameOptions = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();

            const isPosItem =
                state.frontendConfig.configs.find(
                    (co) => co.name === 'enable-pos-item',
                )?.value === 'true';

            const gameList = await gamesApi.getGameOptions(isPosItem);
            dispatch({
                type: GAME_LIST,
                payload: gameList,
            });
        } catch (err) {
            console.error(err);
            dispatch(GameHighlightsError(err, GAME_HIGHLIGHT_LIST_PAGE_TARGET));
        } finally {
            dispatch(setLoading(false));
        }
    };
};

export const setAction = (action) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_ACTION,
                payload: action,
            });
        } catch (err) {
            console.error(err);
        }
    };
};

export const getGameHighlightList = (args) => {
    return async (dispatch) => {
        try {
            const gameHighlightList =
                await gamesApi.getGameHighlightsList(args);
            dispatch({
                type: GET_GAME_HIGHLIGHT_LIST,
                payload: gameHighlightList,
            });
        } catch (err) {
            console.error(err);
            dispatch(GameHighlightsError(err, GAME_HIGHLIGHT_LIST_PAGE_TARGET));
        } finally {
            dispatch(setLoading(false));
        }
    };
};

export const getGameHighlightColors = () => {
    return async (dispatch) => {
        try {
            const colours = await gamesApi.getGameHighlightsColours();
            dispatch({
                type: GAME_HIGHLIGHT_COLOURS,
                payload: colours,
            });
        } catch (err) {
            console.error(err);
            dispatch(GameHighlightsError(err, GAME_HIGHLIGHT_LIST_PAGE_TARGET));
        } finally {
            dispatch(setLoading(false));
        }
    };
};

export const initGameHighlightsList = () => {
    return async (dispatch) => {
        try {
            dispatch({
                type: INIT_GAME_HIGHLIGHT_LIST,
            });
        } catch (err) {
            console.error(err);
        }
    };
};

export const updateNewGameChecked = (checked) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: UPDATE_NEW_GAME_CHECKED,
                payload: checked,
            });
        } catch (err) {
            console.error(err);
        }
    };
};

export const initCurrentGameHighlight = () => {
    return async (dispatch) => {
        try {
            dispatch({
                type: INIT_CURRENT_GAME,
            });
        } catch (err) {
            console.error(err);
        }
    };
};

export const updateCurrentGameHighlight = (state) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: CURRENT_GAME_HIGHLIGHT,
                payload: state,
            });
        } catch (err) {
            console.error(err);
        }
    };
};

export const setLoading = (loading) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_LOADING,
                payload: loading,
            });
        } catch (err) {
            console.error(err);
        }
    };
};

export const saveGameHighlight = (payload) => {
    return async (dispatch) => {
        try {
            await gamesApi.saveGameHighlights(payload);
        } catch (err) {
            console.error(err);
            dispatch(
                GameHighlightsError(err, GAME_HIGHLIGHT_CREATE_PAGE_TARGET),
            );
            throw err;
        } finally {
            dispatch(setLoading(false));
        }
    };
};

export const getGameStock = (jurisdiction, itemCodes) => {
    return async (dispatch) => {
        try {
            const gameStock = await gamesApi.getGameStock(
                jurisdiction,
                itemCodes,
            );
            dispatch({ type: GAME_STOCK, payload: gameStock });
        } catch (err) {
            console.error(err);
            dispatch(error(err.message));
        }
    };
};

export const deleteGameHighlight = (id) => async (dispatch) => {
    let success = true;
    try {
        await gamesApi.deleteGameHighlight(id);
    } catch (err) {
        success = false;
        dispatch(error({ msg: getErrorMessage(err) }));
    } finally {
        dispatch(setLoading(false));
    }
    return success;
};
